import { USER_FEEDBACK_PATH } from '@/modules/analytics/constants';

type NavGroup = { type: 'group'; title_key: string; items: { text_key: string; link: string }[] };

type NavStandalone = { type: 'standalone'; text_key: string; link: string };

export type NavOption = NavGroup | NavStandalone;

export const getReportOptions = (): NavOption[] => [
  {
    type: 'group',
    title_key: 'common.analytics',
    items: [
      { text_key: 'analytics.overview', link: '/overview' },
      { text_key: 'analytics.ai_agents_nav', link: '/ai-agents' },
      { text_key: 'analytics.human_agents_nav', link: '/human-agents' },
    ],
  },
  {
    type: 'group',
    title_key: 'analytics.personalized_metrics',
    items: [{ text_key: 'analytics.user_feedback', link: USER_FEEDBACK_PATH }],
  },
  { type: 'standalone', text_key: 'analytics.account_chat_logs', link: '/account-chat-logs' },
];
